<template>
  <span dense class="api-search-container" color="lighten-2">
    <v-card-text dense>
      <v-autocomplete
        dense
        fullWidth
        v-model="model"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        @change="makeSelection()"
        color="black"
        item-text="Description"
        item-value="Dist"
        return-object
        hide-no-data
        no-filter
        clearable
        placeholder="Start typing to Search"
        ref="searchTextBox"
      >
        <template v-slot:item="{ item }">
          <div class="item-container">
            <div
              v-html="highlight(item.statename + ' (' + item.stusps + ')')"
              class="item-state-name"
            ></div>
            <div
              v-html="highlight(item.districtname)"
              class="item-dist-name"
            ></div>
          </div>
        </template>
      </v-autocomplete>
    </v-card-text>
    <v-divider></v-divider>
    <!-- <v-expand-transition>
      <v-list v-if="model" class="lighten-3">
        <v-list-item v-for="(field, i) in fields" :key="i">
          <v-list-item-content>
            <v-list-item-title v-text="field.value"></v-list-item-title>
            <v-list-item-subtitle v-text="field.key"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-expand-transition> -->
  </span>
</template>

<script>
import { Config } from "../../../data/Config/Config";
import { EventBus } from "../../../data/EventBus";
export default {
  name: "APISearch",
  data: () => ({
    descriptionLimit: 10,
    entries: [],
    isLoading: false,
    model: null,
    search: null,
  }),
  mounted: function(){
    EventBus.$on('clear-search',this.clear);
    
  },
  computed: {
    // fields() {
    //   if (!this.model) return [];

    //   return Object.keys(this.model).map((key) => {
    //     return {
    //       key,
    //       value: this.model[key] || "n/a",
    //     };
    //   });
    // },
    items() {
      const _itemDesc = this.entries.map((entry) => {
        //console.log(entry)

        const Description = `${entry.stusps}-${entry.districtname}`;

        return Object.assign({}, entry, { Description });
      });
      //console.log(_itemDesc)
      return _itemDesc;
    },
  },
  methods: {
    makeSelection: function () {
      const selectedGeoid = this.$refs.searchTextBox.internalValue
        ? this.$refs.searchTextBox.internalValue.geoid || "-1"
        : "-1";
      //console.log(selectedGeoid)
      //select-fips-from-search
      //EventBus.$emit("select-fips", { fips: selectedGeoid });
      //this.$store.commit('setDistrictFIPS', selectedGeoid);
      EventBus.$emit("select-fips-from-search", selectedGeoid );
    },
    highlight: function (str) {
      const substr = [...new Set(this.$refs.searchTextBox.internalSearch.split(""))].join("");
      
      const strArray = str.split("");
      //console.log(strArray.length)
      for (var i = 0; i < strArray.length; i++) {
        if(
          substr.indexOf(strArray[i])>-1 
        || 
        substr.indexOf(strArray[i].toUpperCase())>-1
        || 
        substr.indexOf(strArray[i].toLowerCase()) > -1
        ){
          strArray[i] = strArray[i].bold();
        }
      }
      // str = str.replace(substr, substr.bold());
      return strArray.join("");
    },
    clear: function(){
      this.search = ''
    }
  },
  watch: {
    search(val) {
      // Items have already been loaded
      //if (this.items.length > 0) return;

      // Items have already been requested
      //if (this.isLoading) return;
      if (!val) return;

      this.isLoading = true;

      // Lazily load input items
      fetch(
        `${Config.api.hosts.nodeHostAddress}/autocomplete/${
          this.$store.getters.getDistrictType
        }_demographics/${val.replace("-", " ").replace(",", " ")}`
      )
        .then((res) => res.json())
        .then((res) => {
          const { count, entries } = res;
          this.count = res.length;
          this.entries = res;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>
<style>
.api-search-container {
  display: inline-block;
}

.item-state-name {
  color: slategray;
  font-size: 0.8em;
}

.item-container {
  border-bottom: 1px solid gainsboro;
  padding: 5px 10px;
  width: 100%;
}

b.search-highlight {
  background: lightgrey;
}
</style>